import { useEffect, useState } from "react";
import { config } from "@/config/eventConfig";

const SCRIPT_SRC = "//embed.typeform.com/next/embed.js";

// Nonprofit feedback page. The Typeform is hosted elsewhere, so it is the one
// screen that needs network. It must fail visibly, not hang: an 8s timeout
// reveals the fallback if the embed has not rendered.
export const FeedbackForm = () => {
  const f = config.feedback;
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    // Append the embed script once, even across remounts.
    let script = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
    let appendedHere = false;
    if (!script) {
      script = document.createElement("script");
      script.src = SCRIPT_SRC;
      script.async = true;
      document.body.appendChild(script);
      appendedHere = true;
    }

    // Fail visibly if the embed has not rendered in time.
    const timer = setTimeout(() => {
      const el = document.querySelector(`[data-tf-live="${f.form_id}"]`);
      const rendered = el && el.querySelector("iframe");
      setShowFallback(!rendered);
    }, 8000);

    return () => {
      clearTimeout(timer);
      if (appendedHere && script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [f.form_id]);

  return (
    <div data-testid="feedback-page">
      <p className="mono-label text-orange-dark mb-3">{f.eyebrow}</p>
      <h1 className="font-display text-5xl sm:text-6xl leading-none mb-6">
        {f.title}
      </h1>

      <div className="space-y-4 max-w-2xl mb-6">
        {f.intro.map((p, i) => (
          <p key={i} className="text-ink/80 text-lg">
            {p}
          </p>
        ))}
      </div>

      <div data-testid="feedback-volunteer-note" className="callout-guidance text-teal mb-8">
        {f.volunteer_note}
      </div>

      {/* Typeform embed target. The script hydrates this div. */}
      <div
        data-testid="feedback-embed"
        data-tf-live={f.form_id}
        className="min-h-[500px]"
      />

      {showFallback && (
        <div data-testid="feedback-fallback" className="callout-warning mt-6">
          <p className="mono-label text-orange-dark mb-2">If it will not load</p>
          <p className="text-ink/80">
            {f.fallback}
            {f.form_url && (
              <>
                {" "}
                <a
                  data-testid="feedback-fallback-link"
                  href={f.form_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline underline-offset-4 text-orange-dark"
                >
                  Open the form in a new tab
                </a>
                .
              </>
            )}
          </p>
        </div>
      )}
    </div>
  );
};
